import { Box, Typography, Drawer } from '@material-ui/core'
import { FunctionComponent } from 'react'
import styled from 'styled-components/macro'
//@ts-ignore
import { useTheme } from 'styled-components'
import { AdminDrawer } from './eventManagement/AdminDrawer'
import { AdminDrawerState } from './eventManagement/models/AdminDrawerStore'

interface AdminSideNavProps {}

export const AdminSideNav: FunctionComponent<AdminSideNavProps> = () => {
  const theme = useTheme()
  const StyledDrawer = styled(Drawer)`
    .MuiDrawer-paper {
      top: unset;
      min-width: 20em;
      position: absolute;
    }
  `
  return (
    <StyledDrawer
      variant="permanent"
      style={{
        display: 'block',
        backgroundColor: theme.colors.supplementary,
      }}
    >
      <Typography>
        <Box fontWeight="bold" textAlign="left" color={theme.colors.accent1} marginTop="5em" marginLeft="1em">
          Administrator
        </Box>
      </Typography>
     <Box position='relative'>
      <AdminDrawer AdminDrawerState={AdminDrawerState} />
     </Box>
    </StyledDrawer>
  )
}
